export default function BrandStory() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-6 text-center">
          品牌故事
        </h2>

        <div className="relative aspect-[21/9] rounded-lg overflow-hidden mb-8">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20sunlight%20streaming%20through%20a%20large%20window%20into%20a%20minimalist%20studio%2C%20a%20wooden%20desk%20with%20a%20typewriter%20and%20fresh%20flowers%2C%20cream%20walls%2C%20floating%20dust%20motes%20in%20golden%20light%2C%20peaceful%20and%20creative%20atmosphere%2C%20warm%20beige%20and%20cream%20tones%2C%20artistic%20workspace%2C%20fine%20art%20interior%20photography&width=1200&height=500&seq=about-brand-story&orientation=landscape"
            alt="长日光阴 - 品牌故事"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>

        <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          <p>
            「长日光阴」诞生于2024年的一个寻常午后。创始人苏晚在翻看外婆留下的老相册时，被那些泛黄照片中流淌出的从容与温暖深深打动——那个时代的人们，似乎拥有一种我们现在已经失去的能力：<strong>把平凡的日子过成诗</strong>。
          </p>
          <p>
            于是，「长日光阴」应运而生。它不是一个商业品牌，而是一群人共同的生活实践。我们相信，慢生活不是避世，而是在日常中找到属于自己的节奏；不是懒惰，而是一种<strong>对生命质量的清醒选择</strong>。
          </p>
          <p>
            从一篇晨间茶道的文章开始，到如今涵盖慢生活、时光记录、生活美学、岁月感、治愈系生活、慢时光六大主题的内容平台，「长日光阴」已经陪伴超过<strong>五十万读者</strong>在匆忙的世界里，找到一扇可以慢下来的窗。
          </p>
          <p>
            我们的内容团队由一群热爱生活的创作者组成——有旅居日本多年的茶道爱好者，有走遍中国古镇的独立摄影师，有在景德镇潜心制陶的手艺人。每一个人都在用自己的方式，<strong>实践并记录着慢生活的多种可能</strong>。
          </p>
          <p>
            长日光阴，珍藏每一寸慢时光。这不只是一句口号，而是我们每一天都在做的事。
          </p>
        </div>
      </div>
    </section>
  );
}